var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8574 34.6842C20.9927 34.7009 11.9875 25.5885 12 13.8268C12 13.0577 12.6231 12.4319 13.3908 12.4319H17.0624C17.7508 12.4319 18.3364 12.9381 18.4379 13.6196C18.68 15.2538 19.1554 16.8449 19.8495 18.344L19.9928 18.6528C20.089 18.8606 20.1097 19.0954 20.0513 19.3168C19.9929 19.5382 19.8591 19.7323 19.6729 19.8655C18.5352 20.6777 18.1013 22.3119 18.9872 23.5858C20.1026 25.1899 21.4947 26.5824 23.0983 27.6983C24.3737 28.5829 26.0078 28.149 26.8187 27.0127C26.9518 26.826 27.146 26.6916 27.3677 26.633C27.5895 26.5743 27.8247 26.595 28.0328 26.6914L28.3402 26.8333C29.8394 27.5287 31.4304 28.0043 33.0646 28.2463C33.7461 28.3478 34.2523 28.9333 34.2523 29.6232V33.2934C34.2523 33.4762 34.2163 33.6571 34.1463 33.826C34.0763 33.9948 33.9738 34.1482 33.8445 34.2773C33.7152 34.4065 33.5617 34.5089 33.3928 34.5787C33.2239 34.6485 33.0429 34.6844 32.8602 34.6842H32.8574Z",
    fill: "#43377C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3841,
    cy: 22.8164,
    r: 21.7523,
    stroke: "#43377C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.27b6a9cfdd2686c518945cd7869bf14f.svg";
export { ForwardRef as ReactComponent };